import { render, staticRenderFns } from "./GridBlogPosts.vue?vue&type=template&id=39532d84&"
import script from "./GridBlogPosts.vue?vue&type=script&lang=js&"
export * from "./GridBlogPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39532d84')) {
      api.createRecord('39532d84', component.options)
    } else {
      api.reload('39532d84', component.options)
    }
    module.hot.accept("./GridBlogPosts.vue?vue&type=template&id=39532d84&", function () {
      api.rerender('39532d84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/blogPosts/grid/GridBlogPosts.vue"
export default component.exports